export var HomesReservationState;
(function (HomesReservationState) {
    HomesReservationState["Future"] = "Future";
    HomesReservationState["Present"] = "Present";
    HomesReservationState["Past"] = "Past";
    HomesReservationState["Canceled"] = "Canceled";
})(HomesReservationState || (HomesReservationState = {}));
export var HomeChangeQuoteResponseEnum;
(function (HomeChangeQuoteResponseEnum) {
    HomeChangeQuoteResponseEnum["HomesCancelQuoteSuccess"] = "HomesCancelQuoteSuccess";
    HomeChangeQuoteResponseEnum["HomesChangeQuoteFailure"] = "HomesChangeQuoteFailure";
})(HomeChangeQuoteResponseEnum || (HomeChangeQuoteResponseEnum = {}));
export var HomesCancelScenarioEnum;
(function (HomesCancelScenarioEnum) {
    HomesCancelScenarioEnum["AgentReviewAndFulfillment"] = "AgentReviewAndFulfillment";
    HomesCancelScenarioEnum["Canceled"] = "Canceled";
    HomesCancelScenarioEnum["ContactCustomerService"] = "ContactCustomerService";
    HomesCancelScenarioEnum["FullyRefundable"] = "FullyRefundable";
    HomesCancelScenarioEnum["NonRefundablePartially"] = "NonRefundablePartially";
    HomesCancelScenarioEnum["RefundablePastCheckInDate"] = "RefundablePastCheckInDate";
    HomesCancelScenarioEnum["PartiallyRefundable"] = "PartiallyRefundable";
    HomesCancelScenarioEnum["PastCheckInDate"] = "PastCheckInDate";
})(HomesCancelScenarioEnum || (HomesCancelScenarioEnum = {}));
export var HomesCancelAgentFullfillResponseEnum;
(function (HomesCancelAgentFullfillResponseEnum) {
    HomesCancelAgentFullfillResponseEnum["HomesCancelAgentFulfillSuccess"] = "HomesCancelAgentFulfillSuccess";
    HomesCancelAgentFullfillResponseEnum["HomesCancelAgentFulfillFailure"] = "HomesCancelAgentFulfillFailure";
})(HomesCancelAgentFullfillResponseEnum || (HomesCancelAgentFullfillResponseEnum = {}));
//# sourceMappingURL=homesItinerary.js.map